import type { FC } from "react";
import React from "react";
import { Trans, useTranslation } from "@edreamsodigeo/frontend-core";

import { useFilterOfferByType } from "~/clientState/hooks/useFilterOfferByType";
import useGetSubscriptionOffers from "~/clientState/hooks/useGetSubscriptionOffers";
import { useIsActivePrimeMarket } from "~/clientState/hooks/usePrimeSitePropertiesQuery";
import { OnlineFunnel } from "~/constants/Funnel";
import type { SubscriptionResponse } from "~/generated/graphql";
import {
  SubscriptionOfferPeriod,
  SubscriptionOfferType,
} from "~/generated/graphql";
import {
  freeTrialDays,
  RenewalPrice,
  renewalTimeKey,
} from "~/tools/subscriptionUtils";
import WaitingMessage from "../common/WaitingMessage";

const WaitingPaxPrimeMessage: FC = () => {
  const { t } = useTranslation();
  const { offers: offersList } = useGetSubscriptionOffers({
    offerPeriod: SubscriptionOfferPeriod.FreeTrial,
  });
  const basicOffer: SubscriptionResponse | undefined = useFilterOfferByType({
    offersList,
    subscriptionOfferType: SubscriptionOfferType.Basic,
  });
  const plusOffer: SubscriptionResponse | undefined = useFilterOfferByType({
    offersList,
    subscriptionOfferType: SubscriptionOfferType.Plus,
  });

  const isActivePrimeMarket = useIsActivePrimeMarket(OnlineFunnel.FLIGHTS);

  if (!isActivePrimeMarket || !basicOffer || !plusOffer) {
    return null;
  }

  return (
    <WaitingMessage
      translatedTitle={t("waitings.paxStep.title")}
      translatedDescription={
        <Trans
          i18nKey={"waitings.paxStep.description"}
          values={{
            freeTrialDays: freeTrialDays(basicOffer.duration),
            freeTrialPeriod: t("prime.renewalDuration.days"),
            renewalPlusPrice: plusOffer.renewalPrice.amount,
            renewalTime: t(renewalTimeKey(basicOffer.renewalDuration)),
            renewalPlusTime: t(renewalTimeKey(plusOffer.renewalDuration)),
          }}
          components={{
            renewalPrice: (
              <RenewalPrice
                currency={basicOffer.renewalPrice.currency}
                amount={basicOffer.renewalPrice.amount}
              />
            ),
            renewalPlusPrice: (
              <RenewalPrice
                currency={plusOffer.renewalPrice.currency}
                amount={plusOffer.renewalPrice.amount}
              />
            ),
          }}
        />
      }
    />
  );
};

export default WaitingPaxPrimeMessage;
